<common-line-chart chartType="bar" [data]="monthlyData" [options]="{ yAxisTicksFormat: 'none' }"></common-line-chart>
